(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('SettingsController', settings);

  settings.$inject = ['$http', '$state', 'FoundationApi', 'NotificationService', 'AuthenticationService', '$rootScope'];

  function settings ($http, $state, FoundationApi, NotificationService, AuthenticationService, $rootScope) {
    var vm = this;

    vm.password = null;

    vm.updateSettings = function () {
      $http.patch(apiUrl + '/users/' + $rootScope.user_data + '/settings', {
        settings: $rootScope.user_data.settings,
        id: $rootScope.user_data.id
      })
        .then(function () {
          NotificationService.successHandler(null, $rootScope.labels.sucChangeConfig);
        }, function (error) { console.log(error) });
    }
  }
})();
